import {
  getMappingsUrl,
  getMappingUrl,
  getSyncedMappingsUrl,
} from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class MappingsService {
  static addMapping = (
    originId,
    destinationId,
    degreesOfLearning,
    assignmentTypes,
    ploAssignmentTypes,
    iloAssignmentTypes,
    addUpcomingVersions,
    futureMapping,
    isDefaultOffering,
    setLoSync
  ) => {
    const params = {
      originId,
      destinationId,
      degreesOfLearning: degreesOfLearning || "",
      assignmentTypes,
      ploAssignmentTypes,
      iloAssignmentTypes,
      addUpcomingVersions,
      futureMapping,
      createFutureMappings: true,
      isDefaultOffering,
      setLoSync,
    };
    return postRequest(getMappingsUrl(), params);
  };

  static updateMapping = (
    mappingId,
    originId,
    destinationId,
    degreesOfLearning,
    assignmentTypes,
    ploAssignmentTypes,
    iloAssignmentTypes,
    editUpcomingVersions,
    futureMapping,
    isDefaultOffering,
    setLoSync
  ) => {
    const params = {
      originId,
      destinationId,
      degreesOfLearning: degreesOfLearning || "",
      assignmentTypes,
      ploAssignmentTypes,
      iloAssignmentTypes,
      editUpcomingVersions,
      updateFutureMappings: true,
      futureMapping,
      isDefaultOffering,
      setLoSync,
    };
    return putRequest(getMappingsUrl() + "/" + mappingId, params);
  };

  static deleteMapping = (
    mappingId,
    deleteUpcomingVersions,
    deleteFutureMappings,
    futureMapping,
    isDefaultOffering
  ) => {
    const params = {
      deleteUpcomingVersions,
      deleteFutureMappings,
      futureMapping,
      isDefaultOffering,
    };
    return deleteRequest(getMappingUrl(mappingId), params);
  };

  static getAllSyncedMappingsForContext = (contextId, futureMapping) => {
    const params = { futureMapping: !!futureMapping };
    if (futureMapping) {
      params.termId = futureMapping.term.id;
    }

    return getRequest(getSyncedMappingsUrl(contextId), params);
  };
}
